/**
 * @readonly
 * @enum {string}
 */
export const MediaType = {
  ApplicationJSON: 'application/json',
  ApplicationPDF: 'application/pdf',
  ImageJPEG: 'image/jpeg',
  ImagePNG: 'image/png',
  MultipartFormData: 'multipart/form-data',
  TextCSV: 'text/csv',
};
